import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg24Message1 = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M11.83 2C6.468 2 2 5.743 2 10.35c0 4.608 4.47 8.36 9.83 8.36l.407-.008q.815-.03 1.616-.178l.066-.013-.266-.213a10.6 10.6 0 0 0 3.673 1.982 1.11 1.11 0 0 0 1.172-.383c.27-.347.307-.82.096-1.204l-.18-.303a7.7 7.7 0 0 1-.563-1.25l-.046-.145a8.12 8.12 0 0 0 3.855-6.62C21.66 5.743 17.192 2 11.83 2m0 1.4c4.638 0 8.43 3.177 8.43 6.95a6.71 6.71 0 0 1-3.604 5.69.7.7 0 0 0-.356.788l.105.387q.171.577.417 1.125l.158.335-.281-.118a9.2 9.2 0 0 1-2.152-1.335.7.7 0 0 0-.6-.145 9.7 9.7 0 0 1-2.117.233c-4.636 0-8.43-3.185-8.43-6.96 0-3.773 3.792-6.95 8.43-6.95"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24Message1$1 = Svg24Message1;

export { Svg24Message1$1 as default };
